import "./FullScore.css"
import {t} from "../../../i18n";
import Score from "./Score";
import {DecodeScoreDetail} from "../../../javaTypes";

export type ScoreType = DecodeScoreDetail

export default function FullScore({score, otherScore, color, right, currentPeriod, hrReview, keyPanel, isSingleTeam, isPlayoff}: {
    score: Partial<DecodeScoreDetail>,
    otherScore: Partial<DecodeScoreDetail>,
    color: 'red' | 'blue' | 'orange',
    currentPeriod: 'auto' | 'auto_transition' | 'teleop' | 'endgame' | 'review' | null
    right?: boolean,
    hrReview?: boolean,
    keyPanel?: 'auto' | 'teleop' | 'shared' | 'all',
    isSingleTeam?: boolean,
    isPlayoff?: boolean
}) {
    const hrReviewMarker = <div className={"hrReview"}>{t`Match Under Review`}</div>;

    return <div className={`fullScore ${color} ${right ? 'right' : ''} ${isSingleTeam ? 'singleTeam' : ''}`}>
        <div className={`${!right && keyPanel === 'auto' ? 'keyPanel' : ''} autoPanel`}>
            { currentPeriod === 'review' && hrReview ? hrReviewMarker : null}
            <div className={"sectionWrapper"}>
                <div className={`sectionHeading`}>{t`AUTO`}</div>
                {currentPeriod === 'auto' ? <div className={"currentPeriod"}>{isSingleTeam ? t`Current` : t`Current Period`}</div> : null}
            </div>
            <Score score={score} color={color} right={right} isSingleTeam={isSingleTeam} isAuto isPlayoff={isPlayoff} />
        </div>
        <div className={`${!right && keyPanel === 'teleop' ? 'keyPanel' : ''} `}>
            <div className={`teleopPanel`}>
                <div className={"sectionWrapper"}>
                    <div className={`sectionHeading`}>{t`TELEOP`}</div>
                    {currentPeriod === 'teleop'  || currentPeriod === 'endgame' ? <div className={"currentPeriod"}>{isSingleTeam ? t`Current` : t`Current Period`}</div> : null}
                </div>
                <Score score={currentPeriod?.startsWith('auto') ? {} : score} color={color} right={right} isSingleTeam={isSingleTeam} isPlayoff={isPlayoff} />
            </div>
        </div>
    </div>
}